import { render, staticRenderFns } from "./VisiosList.vue?vue&type=template&id=68b5bf83"
import script from "./VisiosList.vue?vue&type=script&lang=js"
export * from "./VisiosList.vue?vue&type=script&lang=js"
import style0 from "./VisiosList.vue?vue&type=style&index=0&id=68b5bf83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports